import { forwardRef } from "react";
import { Tooltip as KTooltip } from "@progress/kendo-react-tooltip";
import clsx from "clsx";

import "./Tooltip.scss";

import type {
  TooltipPosition as KTooltipPosition,
  TooltipProps as KTooltipProps,
} from "@progress/kendo-react-tooltip";

export interface TooltipProps extends KTooltipProps {
  type?: "info";
  visuallyHidden?: boolean;
}

export const Tooltip = forwardRef((props: TooltipProps, _ref) => {
  const { className, ...otherProps } = props;

  return (
    <KTooltip
      ref={_ref}
      className={clsx("tc-tooltip", className, {
        "info-tooltip": props.type === "info",
        "tooltip-hidden": props.visuallyHidden,
      })}
      {...otherProps}
    >
      {props.children}
    </KTooltip>
  );
});

export type { KTooltipPosition as TooltipPosition };

export default Tooltip;
